import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire, mapSectionToPage } from 'Consts/Questionnaire';
import { questionnaireSectionNotes as enumeratedValuesQuestionnaireSectionNotes } from 'Consts/EnumeratedValues';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';

function getEditButton(simpleHousehold, reco, isAgent) {
  if (reco.type === 'questionnaireSectionNote') {
    const page = mapSectionToPage(reco.attributes.sectionId);
    const link = editQuestionnaire(page, {
      isAgent,
      section: reco.attributes.sectionId,
      householdId: simpleHousehold.householdResource.id(),
    });

    return (
      <EditButtonLink
        title="Edit Recommendation"
        to={link}
      />
    );
  }

  return null;
}

const Recos = ({ recos, isAgent }) => {
  const simpleHousehold = useSimpleHousehold();
  return (
    <div className="recommendations section">
      <div className="heading">
        <h4 className="bordered">Recommendations</h4>
      </div>
      {recos.length > 0 ? (
        <div className="color-bullets-list">
          {recos.map((reco, i) => (
            <div key={`${reco.id}reco`} className="reco">
              <div className="owner">
                <span className="number">{i + 1}</span>
                {reco.meta.agent.firstName}
                &nbsp;
                {reco.meta.agent.lastName}
                &nbsp;
                {moment(reco.attributes.createdAt).format('MM/DD/YYYY')}
                {getEditButton(simpleHousehold, reco, isAgent)}
              </div>
              <div className="content">
                {enumeratedValuesQuestionnaireSectionNotes(
                  'section',
                  reco.attributes.sectionId,
                ).toUpperCase()}
                &nbsp;&middot;&nbsp;
                {reco.attributes.content}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>No recommendations.</div>
      )}
    </div>
  );
};

Recos.propTypes = {
  recos: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default Recos;
